import React from 'react'
import { CREATOR_APP_URL } from 'constants/global'
import inModal from 'utils/hoc/inModal'

import './InsufficientPermissionsError.scss'

type InsufficientPermissionsErrorProps = {
    missing_permissions: Record<string, string>
    onClose: () => void
}

const InsufficientPermissionsError: React.FC<InsufficientPermissionsErrorProps> = ({
    missing_permissions,
    onClose,
}) => {
    const entries = Object.entries(missing_permissions)

    return (
        <div className="insufficient-permissions-error">
            <div className="insufficient-permissions-error__hero pt-3">
                <div className="insufficient-permissions-error__icon-wrap" aria-hidden>
                    <i className="ri-shield-keyhole-line insufficient-permissions-error__icon" />
                </div>
                <p className="insufficient-permissions-error__intro">
                    This campaign needs extra account permissions before you can apply on this. Ask the
                    creator to sign in at influns app or <a href={CREATOR_APP_URL} target="_blank" rel="noopener noreferrer">
                    {CREATOR_APP_URL.replace(/^https?:\/\//, '')}
                </a> and connect their account so these permissions can
                    be granted.
                </p>
            </div>

            {entries.length > 0 ? (
                <div>
                    <p className="insufficient-permissions-error__list-title">Required permissions</p>
                    <ul className="insufficient-permissions-error__list">
                        {entries.map(([permission, description]) => (
                            <li key={permission} className="insufficient-permissions-error__item">
                                <span className="insufficient-permissions-error__item-meta">
                                    <span className="insufficient-permissions-error__item-label">{description}</span>
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            ) : (
                null
            )}

            <p className="insufficient-permissions-error__cta">
                Ask creator to authorize their account with these permissions on influns app or {' '}
                <a href={CREATOR_APP_URL} target="_blank" rel="noopener noreferrer">
                    {CREATOR_APP_URL.replace(/^https?:\/\//, '')}
                </a>
            </p>

            <div className="insufficient-permissions-error__actions">
                <button type="button" className="theme-btn btn-primary" onClick={onClose}>
                    Got it
                </button>
            </div>
        </div>
    )
}

export default inModal(InsufficientPermissionsError, 'Insufficient Permissions', {
    id: 'insufficient-permissions-error',
    dialogClassName: 'insufficient-permissions-error-dialog',
    modalClassName: 'insufficient-permissions-error-modal',
    scrollable: true,
    modalBodyClassName: 'insufficient-permissions-error-body',
})
